/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/CourseCountdown/theme';

export const CourseCountdownTheme = theme;
